"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.DropdownButton = exports.ConfirmButton = exports.Button = exports.ActionButton = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("../../button"));

var _actionButtons = _interopRequireDefault(require("../../actionButtons"));

var _confirmationModal = _interopRequireDefault(require("../../modal/confirmationModal"));

var _dropdown = _interopRequireDefault(require("../../dropdown"));

var _context2 = require("../context");

var _utils = require("../utils");

var _excluded = ["actionType"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context3, _context4; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(source), !0)).call(_context3, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var TableAction = function TableAction(_ref) {
  var actionType = _ref.actionType,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var openModal = function openModal() {
    return setOpen(true);
  };

  var closeModal = function closeModal() {
    return setOpen(false);
  };

  var _useTable = (0, _context2.useTable)(),
      selectedRows = _useTable.selectedRows,
      selectedRow = _useTable.selectedRow,
      data = _useTable.data,
      uniqueDataKey = _useTable.uniqueDataKey,
      multiSelect = _useTable.multiSelect,
      paginationEnabled = _useTable.paginationEnabled;

  var currentRows = selectedRows;

  if (paginationEnabled) {
    var allRowIds = data ? (0, _map["default"])(data).call(data, function (obj) {
      return obj[uniqueDataKey];
    }) : [];
    currentRows = (0, _filter["default"])(selectedRows).call(selectedRows, function (rowId) {
      return (0, _includes["default"])(allRowIds).call(allRowIds, rowId);
    });
  }

  var selectedItems = (0, _react.useMemo)(function () {
    return (0, _filter["default"])(data).call(data, function (item) {
      return (0, _includes["default"])(selectedRows).call(selectedRows, item[uniqueDataKey]);
    });
  }, [selectedRows, data, uniqueDataKey]);
  var selectedRowItem = (0, _react.useMemo)(function () {
    return !multiSelect ? (0, _find["default"])(data).call(data, function (item) {
      return item[uniqueDataKey] === selectedRow;
    }) : null;
  }, [selectedRow, data, uniqueDataKey, multiSelect]);

  var itemSelectHandler = function itemSelectHandler(item) {
    if (multiSelect) {
      props.onItemClick(item, selectedRows, selectedItems);
    } else {
      props.onItemClick(item, selectedRow, selectedRowItem);
    }
  };

  if (actionType === "button") {
    return /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({}, props, {
      disabled: currentRows.length === 0 && selectedRow === null || props.disabled,
      onClick: (0, _utils.isFunction)(props.onClick) ? function () {
        return multiSelect ? props.onClick(currentRows, selectedItems) : props.onClick(selectedRow, selectedRowItem);
      }
      /* istanbul ignore next */
      : null
    }));
  }

  if (actionType === "actionButton") {
    var _context;

    var buttons = (0, _map["default"])(_context = props.buttons).call(_context, function (btn) {
      return _objectSpread(_objectSpread({}, btn), {}, {
        disabled: currentRows.length === 0 && selectedRow === null || btn.disabled,
        onClick: function onClick() {
          /* istanbul ignore else */
          if ((0, _utils.isFunction)(btn.onClick)) {
            if (multiSelect) {
              btn.onClick(currentRows, selectedItems);
            } else {
              btn.onClick(selectedRow, selectedRowItem);
            }
          }
        }
      });
    });
    return /*#__PURE__*/_react["default"].createElement(_actionButtons["default"], (0, _extends2["default"])({}, props, {
      buttons: buttons,
      disableMoreBtn: currentRows.length === 0 && selectedRow === null || props.disableMoreBtn
    }));
  }
  /* istanbul ignore else */


  if (actionType === "confirmButton") {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-fragments
      _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_confirmationModal["default"], (0, _extends2["default"])({}, props, {
        size: props.modalSize,
        isOpen: isOpen,
        toggle: closeModal,
        onContinue: function onContinue() {
          /* istanbul ignore else */
          if ((0, _utils.isFunction)(props.onContinue)) {
            var result = _promise["default"].resolve(true);

            if (multiSelect) {
              result = props.onContinue(currentRows, selectedItems);
            } else {
              result = props.onContinue(selectedRow, selectedRowItem);
            }
            /* istanbul ignore else */


            if (result instanceof _promise["default"]) {
              result.then(function () {
                return closeModal();
              });
            }
          }
        }
      })), /*#__PURE__*/_react["default"].createElement(Button, (0, _extends2["default"])({}, props, {
        disabled: currentRows.length === 0 && selectedRow === null || props.disabled,
        onClick: openModal
      })))
    );
  }

  if (actionType === "dropDownButton") {
    return /*#__PURE__*/_react["default"].createElement(_dropdown["default"], {
      className: props.className,
      items: props.items,
      disabled: currentRows.length === 0 && selectedRow === null || props.disabled,
      label: props.label,
      type: props.type,
      onItemClick: itemSelectHandler
    });
  }

  return null;
};

TableAction.defaultProps = {
  modalSize: "md"
};
TableAction.propTypes = {
  modalSize: _propTypes["default"].string,
  actionType: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onContinue: _propTypes["default"].func,
  disableMoreBtn: _propTypes["default"].bool,
  buttons: _propTypes["default"].array
};

var Button = function Button(props) {
  return /*#__PURE__*/_react["default"].createElement(TableAction, (0, _extends2["default"])({}, props, {
    actionType: "button"
  }));
};

exports.Button = Button;

var ConfirmButton = function ConfirmButton(props) {
  return /*#__PURE__*/_react["default"].createElement(TableAction, (0, _extends2["default"])({}, props, {
    actionType: "confirmButton"
  }));
};

exports.ConfirmButton = ConfirmButton;

var ActionButton = function ActionButton(props) {
  return /*#__PURE__*/_react["default"].createElement(TableAction, (0, _extends2["default"])({}, props, {
    actionType: "actionButton"
  }));
};

exports.ActionButton = ActionButton;

var DropdownButton = function DropdownButton(props) {
  return /*#__PURE__*/_react["default"].createElement(TableAction, (0, _extends2["default"])({}, props, {
    actionType: "dropDownButton"
  }));
};

exports.DropdownButton = DropdownButton;